import React from 'react';
import Contact from './Contact';
import { Link } from 'react-router-dom';


const AboutPage = () => {
  return (
    <div className="bg-gray-900 text-white">
      {/* Hero Section */}
      <section className="bg-gray-800 py-12 px-2">
        <div className="container mx-auto text-center">
          <h1 className="text-4xl font-bold mb-4">About </h1>
          <p className="text-lg">Me Sumit Baghel, developer of this project, let's scroll and dive into details. </p>
        </div>
      </section>

      {/* Company Overview Section */}
      <section className="py-12 px-2">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4 text-center">My Journey</h2>
          <p className="text-gray-400 text-center mb-8">I started with a vision to create a platform where people can explore videos effortlessly.</p>
          <div className="flex flex-wrap justify-center">
            <div className="w-full md:w-1/2 lg:w-1/3 p-4">
              <div className="bg-gray-800 rounded-lg p-6 shadow-md">
                <h3 className="text-2xl font-semibold mb-2">Founded</h3>
                <p className="text-gray-400">I am the founder of this Project and I had started creating this project in mid of April.</p>
              </div>
            </div>
           
            <div className="w-full md:w-1/2 lg:w-1/3 p-4">
              <div className="bg-gray-800 rounded-lg p-6 shadow-md">
                <h3 className="text-2xl font-semibold mb-2">Future</h3>
                <p className="text-gray-400">I aim to continue evolving, bringing more features and better user experiences.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="bg-gray-800 py-12 px-2">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4"> Mission</h2>
          <p className="text-gray-400 mb-8">Anyone can explore our product effortlessly just similar to <span className='text-red-500'>YouTube</span></p>
          <div className="flex justify-center">
            <div className="bg-gray-700 rounded-lg p-6 shadow-md max-w-md">
              <p className="text-gray-400">I believe in the power of video content to educate, entertain, and inspire. Our mission is to reach and connect with a global audience.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-12 px-2">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4 text-center">Meet Me or message me on LinkedIn</h2>

          <h2 className="text-xl font-semibold mb-4 text-center">
            <a href="https://www.linkedin.com/in/sumit-baghel-463512205" target="_blank" rel="noopener noreferrer" className='text-blue-500 underline'>
              LinkedIn
            </a>
          </h2>
          
          {/* <div className="flex flex-wrap justify-center">
          
            <div className="w-full md:w-1/2 lg:w-1/4 p-4">
              <div className="bg-gray-800 rounded-lg p-6 shadow-md text-center">
                <img className="w-24 h-24 mx-auto rounded-full mb-4" src="https://via.placeholder.com/100" alt="Team Member 1" />
                <h3 className="text-2xl font-semibold mb-2">John Doe</h3>
                <p className="text-gray-400">CEO & Founder</p>
              </div>
            </div>

            <div className="w-full md:w-1/2 lg:w-1/4 p-4">
              <div className="bg-gray-800 rounded-lg p-6 shadow-md text-center">
                <img className="w-24 h-24 mx-auto rounded-full mb-4" src="https://via.placeholder.com/100" alt="Team Member 2" />
                <h3 className="text-2xl font-semibold mb-2">Jane Smith</h3>
                <p className="text-gray-400">CTO</p>
              </div>
            </div>
          
            <div className="w-full md:w-1/2 lg:w-1/4 p-4">
              <div className="bg-gray-800 rounded-lg p-6 shadow-md text-center">
                <img className="w-24 h-24 mx-auto rounded-full mb-4" src="https://via.placeholder.com/100" alt="Team Member 3" />
                <h3 className="text-2xl font-semibold mb-2">Michael Brown</h3>
                <p className="text-gray-400">Head of Marketing</p>
              </div>
            </div>

            <div className="w-full md:w-1/2 lg:w-1/4 p-4">
              <div className="bg-gray-800 rounded-lg p-6 shadow-md text-center">
                <img className="w-24 h-24 mx-auto rounded-full mb-4" src="https://via.placeholder.com/100" alt="Team Member 4" />
                <h3 className="text-2xl font-semibold mb-2">Emily Johnson</h3>
                <p className="text-gray-400">Lead Developer</p>
              </div>
            </div>
          </div> */}

          
        </div>
      </section>

      {/* Contact Section */}
      <Contact about = {true}/>
    </div>
  );
};

export default AboutPage;
